<div class="google-search-container" fxLayout="row" fxLayoutGap="15px" [formGroup]="searchForm">
  <div class="search-container" fxLayout="column">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'GOOGLE_SEARCH.SEARCH_PLACEHOLDER' | translate }}</mat-label>
      <input matInput #searchField formControlName="search"/>
    </mat-form-field>
    <mat-checkbox formControlName="isSearchBound" color="primary">
      {{ 'GOOGLE_SEARCH.LIMIT_TO_BOUNDS' | translate }}
    </mat-checkbox>
  </div>
</div>

<!-- Info Window Content -->
<div class="info-window-content-container">
  <div id="google-search-info-window-content" fxLayout="column">
    <span id="info-window-title" style="color: #333;" class="address-line full-width"></span>
    <a id="info-window-link" style="color: #1a73e8;" target="_blank">
      {{ 'GOOGLE_SEARCH.VIEW_ON_GOOGLE_MAPS' | translate }}
    </a>
  </div>
</div>
